import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import './privacy.css'


const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
};

const PrivacyPolicy = () => {
    const [openSection, setOpenSection] = useState("data");
    const [showScrollTop, setShowScrollTop] = useState(false);

    useEffect(() => {
        const onScroll = () => {
            setShowScrollTop(window.scrollY > 300);
        };
        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const toggleSection = (section) => {
        setOpenSection((prev) => (prev === section ? null : section));
    };

    return (
        <div className="privacy-container">
            <div className="privacy-wrapper">
                <header className="privacy-header">
                    <h1>Politique de Confidentialité – XRapid</h1>
                </header>

                {/* Section 1 */}
                <div className="privacy-section">
                    <button onClick={() => toggleSection("data")} className="privacy-toggle">
                        TRANSFERT, STOCKAGE ET TRAITEMENT DES DONNÉES
                        <span>{openSection === "data" ? "−" : "+"}</span>
                    </button>
                    <AnimatePresence>
                        {openSection === "data" && (
                            <motion.div
                                className="privacy-content"
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                transition={{ duration: 0.3 }}
                            >

                                <p>
                                    Chez <strong>Xrapid</strong>, la confidentialité et la sécurité de vos informations personnelles sont une priorité.
                                    La présente politique de confidentialité décrit les types de données collectées, l’usage qui en est fait,
                                    ainsi que vos droits en matière de protection des données.
                                </p>

                                <h2>1. Informations que nous stockons</h2>
                                <ul>
                                    <li>Votre Nom complet</li>
                                    <li>Votre numéro de téléphone</li>
                                    <li>Le Code de votre compte de jeu X ou W</li>
                                    <li>Les détails de vos transactions (montant, date, type : dépôt ou retrait)</li>
                                    <li>Les informations de diagnostic ou d’erreurs en cas de dysfonctionnement</li>
                                </ul>

                                <h2>2. Utilisation des données</h2>
                                <p>Les données collectées servent à :</p>
                                <ul>
                                    <li>Exécuter les <strong>dépôts et retraits</strong> sur vos comptes de jeu X ou W</li>
                                    <li>Effectuer les <strong>transferts instantanés</strong> vers vos comptes de paiement mobile Mixx Ou Flooz</li>
                                    <li>Vous fournir un <strong>service client réactif et personnalisé</strong></li>
                                    <li>Assurer la <strong>sécurité et la fiabilité</strong> du service</li>
                                    <li>Améliorer nos services et votre expérience utilisateur</li>
                                </ul>

                                <h2>3. Stockage et traitement des données</h2>
                                <p>
                                    Vos données sont stockées de manière sécurisée sur des serveurs protégés et peuvent être traitées
                                    par notre partenaire technique uniquement dans le cadre du bon fonctionnement du service.
                                </p>
                                <p>
                                    Nous veillons à ce que toute transmission ou stockage respecte les normes légales applicables,
                                    notamment dans les juridictions où nous opérons (notamment au Togo).
                                </p>

                                <h2>4. Partage des données</h2>
                                <p>Vos données ne sont <strong>jamais vendues ni cédées</strong> à des tiers. Elles ne sont partagées que dans les cas suivants :</p>
                                <ul>
                                    <li>Avec notre service support en cas de besoin d’assistance</li>
                                </ul>

                                <h2>5. Vos droits</h2>
                                <p>
                                    Conformément aux lois sur la protection des données, vous disposez des droits suivants :
                                </p>
                                <ul>
                                    <li>Accès à vos données personnelles</li>
                                    <li>Rectification ou suppression de vos données</li>
                                    <li>Demande de copie de vos informations (portabilité)</li>
                                </ul>
                                <p>
                                    Pour exercer ces droits, contactez notre équipe à l’adresse email ou via le support intégré à l’application.
                                </p>

                                <h2>6. Cookies et technologies similaires</h2>
                                <p>
                                    Xrapid n’utilise pas actuellement de cookies dans l’application mobile. Cependant, des outils d’analyse anonymes
                                    peuvent être utilisés pour améliorer l’expérience utilisateur.
                                </p>

                                <h2>7. Contact</h2>
                                <p>
                                    Pour toute question relative à la présente politique de confidentialité ou à vos données personnelles,
                                    veuillez contacter le support à travers whatsapp sur l'application.
                                </p>
                                <div className="privacy-note">
                                    <p>
                                        <strong>Les données personnelles</strong> désignent toute information permettant d'identifier directement ou indirectement une personne : nom, numéro de téléphone, etc.
                                        Les informations anonymisées associées à des données personnelles sont également considérées comme personnelles.
                                    </p>
                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>

                {/* Section 2 */}
                <div className="privacy-section">
                    <button onClick={() => toggleSection("changes")} className="privacy-toggle">
                        MODIFICATIONS DE CETTE POLITIQUE
                        <span>{openSection === "changes" ? "−" : "+"}</span>
                    </button>
                    <AnimatePresence>
                        {openSection === "changes" && (
                            <motion.div
                                className="privacy-content"
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <p>
                                    XRapid peut mettre à jour cette politique de confidentialité à tout moment. Nous vous informerons en cas de modifications majeures.
                                </p>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>

                {/* Section 3 */}
                <div className="privacy-section">
                    <button onClick={() => toggleSection("support")} className="privacy-toggle">
                        COMMENTAIRES ET QUESTIONS
                        <span>{openSection === "support" ? "−" : "+"}</span>
                    </button>
                    <AnimatePresence>
                        {openSection === "support" && (
                            <motion.div
                                className="privacy-content"
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <p>
                                    Pour toute question concernant vos données ou cette politique, contactez notre support via l’application.
                                </p>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>

                {/* Section 4 */}
                <div className="privacy-section">
                    <button onClick={() => toggleSection("local")} className="privacy-toggle">
                        DISPOSITIONS LOCALES
                        <span>{openSection === "local" ? "−" : "+"}</span>
                    </button>
                    <AnimatePresence>
                        {openSection === "local" && (
                            <motion.div
                                className="privacy-content"
                                initial={{ opacity: 0, height: 0 }}
                                animate={{ opacity: 1, height: "auto" }}
                                exit={{ opacity: 0, height: 0 }}
                                transition={{ duration: 0.3 }}
                            >
                                <p>
                                    Des lois spécifiques peuvent s'appliquer selon votre région de résidence. Nous respectons les obligations légales locales, notamment en matière de confidentialité et de sécurité des données.
                                </p>
                            </motion.div>
                        )}
                    </AnimatePresence>
                </div>

                <footer className="privacy-footer">
                    Dernière mise à jour : 6 août 2025
                </footer>

                {/* Scroll to Top Button */}
                {showScrollTop && (
                    <button onClick={scrollToTop} className="scroll-top-button" aria-label="Retour en haut">
                        ↑
                    </button>
                )}
            </div>
        </div>
    );
};

export default PrivacyPolicy;